import { useUserStore } from './store/UserStore';
import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';

type ProtectedRouteProps = {
    children: ReactNode;
};

const ProtectedRoute = ({ children }: ProtectedRouteProps): JSX.Element => {
    const isAuthenticated = useUserStore((state) => state.isAuthenticated);

    return isAuthenticated ? <>{children}</> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
